import { Injectable } from '@angular/core';
import { RecipientsPage } from '@routes/campaigns/models/campaign-model';

@Injectable()
export class RecipientPagingService {
  public page: RecipientsPage = {
    'pageNumber': 0,
    'size': 10,
    'filterModel':  {
        'statusFilter': this.getStatusFilter(),
        'mailStatusFilter': this.getMailStatusFilter(),
        'senderFilter': null,
        'contactTypeFilter': this.getContactTypeFilter(),
        'searchValue': '',
        'accountOwnerFilter': null
    },
    'sortProperty': this.getSortProperty(),
    'sortDirection': this.getSortDirection(),
    'totalElements': 0,
    'totalPages': 0
  };

  public setStatusFilter(value: number) {
    localStorage.setItem('recipientsStatusFilter', value.toString());
  }

  public getStatusFilter(): number {
      let value = parseInt(localStorage.getItem('recipientsStatusFilter'), 10);
      if (isNaN(value)) {
        value = 0;
      }

      return value;
  }

  public setMailStatusFilter(value: number) {
    localStorage.setItem('recipientsMailStatusFilter', value.toString());
  }

  public getMailStatusFilter(): number {
      let value = parseInt(localStorage.getItem('recipientsMailStatusFilter'), 10);
      if (isNaN(value)) {
        value = 0;
      }

      return value;
  }

  public setContactTypeFilter(value: number) {
    localStorage.setItem('recipientsContactTypeFilter', value.toString());
  }

  public getContactTypeFilter(): number {
      let value = parseInt(localStorage.getItem('recipientsContactTypeFilter'), 10);
      if (isNaN(value)) {
        value = 0;
      }

      return value;
  }

  public setSortProperty(value: string) {
    if (value) {
      localStorage.setItem('recipientsSortProperty', value);
    } else {
      localStorage.setItem('recipientsSortProperty', '');
    }
  }

  public getSortProperty(): string {
    let value = localStorage.getItem('recipientsSortProperty');
    if (null === value) {
        value = '';
    }

    return value;
  }

  public setSortDirection(value: string) {
    if (value) {
      localStorage.setItem('recipientsSortDirection', value);
    } else {
      localStorage.setItem('recipientsSortDirection', '');
    }
  }

  public getSortDirection(): string {
    let value = localStorage.getItem('recipientSortDirection');
    if (null === value) {
        value = '';
    }

    return value;
  }

}
